import { TaskList } from '@tiptap/extension-list';

export const taskList = TaskList.extend({
    name: 'taskList',

    addKeyboardShortcuts() {
        return {
            'mod-shift-9': () => false,
        };
    },
});
